import { http } from '@/core/api/';
import questionnaireTypes from '@/utils/constants/questionnairetypes';
const apiBaseUrl = 'api/welcomepagequestionnaire';

export default {
  /**
   * Get student notification way
   */
  async getNotificationWays(studentSieId) {
    return http.get(`${apiBaseUrl}/samplenotificationways`, {
      params: {
        studentSieId,
      },
    });
  },

  /**
   * allow to make all validation
   * verify sie info
   * verify if student has complete questionnaire
   * @param {*} studentSie
   * @param {*} birthDate
   */
  async isSieValid(studentSieId, studentBirthDate, token) {
    return http.get(`${apiBaseUrl}/isstudentvalid/`, {
      params: {
        studentSieId,
        studentBirthDate,
        token,
      },
    });
  },

  /**
   * Get inventory questionnaire
   */
  async getQuestionnaire() {
    return http.get(`${apiBaseUrl}/questions`, {
      params: {
        questionnaireType: questionnaireTypes.InventoryParent,
      },
    });
  },

  /**
   * save all answers and return notification number
   * @param {*} studentSie student sie number
   * @param {*} notificationWay selected notification way
   * @param {*} answers array of key/value pairs of selected answers, [{questionId:1, answerId: 10}]
   */
  async saveQuestionnaireAnswers(studentSieId, notificationWayId, answers) {
    return http.post(
      `${apiBaseUrl}/saveanswers?studentSieId=${studentSieId}&notificationWayId=${notificationWayId}`,
      answers
    );
  },
};
